import { dashedToCamelCase } from '../../utils/convert-case';

const getBlockSurfaceName = (surfaceAttribute) => {
  const surface = dashedToCamelCase(surfaceAttribute);
  return [surface.slice(0, 2), 'Surface', surface.slice(2)].join('');
};

export default getBlockSurfaceName;
